<template>
  <section>
    <div  v-if="this.article">
      <Adsense
        data-ad-client="ca-pub-8143206471999291"
        data-ad-slot="5650016694">
      </Adsense>
    </div>
    <p class="article_result">>「{{this.$route.params.id}}」の検索結果</p>
    <div class="article">
        <div class="columns">
          <div class="column main_bar is-8">
            <h1 v-if="this.article"><span class="article_title">{{ article.title }}</span><span class="article_title_sub">の夢の意味は？</span></h1>
            <div v-if="this.article" class="article_content" v-html="article.content"></div>
            <p v-if="!this.article && this.relate_articles.length == 0" style="padding-top:10px;font-weight:bold;font-size:1.2em">{{this.no_article_message}}</p>
            <div v-if="this.article" class="share">
              <ShareComponentArticle/>
              <p>…悪い夢の場合は、夢の内容を友人や知人に話したり、SNSでシェアしてネガティブを解消しましょう。(夢占いでは、良い夢は人に話さない方がよく、逆に悪い夢の場合は人に話した方がいいという説があります。)</p>
              <hr/>
            </div>
            <div v-if="this.article" class="article_ad_bottom">
              <Adsense
                data-ad-client="ca-pub-8143206471999291"
                data-ad-slot="8208446019">
              </Adsense>
            </div>

            <div v-if="this.article" class="appreach">
              <p class="appreach__name">ズバリ！あなたに似ている有名人は？【人気アプリ】</p>
              <img src="https://is5-ssl.mzstatic.com/image/thumb/Purple115/v4/47/17/82/47178288-49a5-2c5f-404a-620225c5b362/source/512x512bb.jpg" alt="顔診断ゲーム" class="appreach__icon">
              <div class="appreach__detail">
                <p class="appreach__name">顔診断ゲーム【無料で遊べるAI顔診断アプリ】</p>
                <p>AIがあなたの顔の特徴を診断、似ている有名人を判定します</p>
                <div class="appreach__links"><a href="https://apps.apple.com/jp/app/%25E9%25A1%2594%25E8%25A8%25BA%25E6%2596%25AD%25E3%2582%25B2%25E3%2583%25BC%25E3%2583%25A0/id1587651420?uo=4" rel="nofollow" class="appreach__aslink"><img src="https://nabettu.github.io/appreach/img/itune_ja.svg"></a></div>
                <p class="appreach__info"><span class="appreach__price">無料</span><span class="appreach__posted">posted with<a href="https://mama-hack.com/app-reach/" title="アプリーチ" target="_blank" rel="nofollow">アプリーチ</a></span></p></div>
            </div>

            <h2 v-if="relate_articles.length > 0">「{{this.$route.params.id}}」を含む夢占い一覧</h2>
            <div class="relate_list" v-for="relate_article in relate_articles" :key="relate_article.id">
              <!-- <a :href="'https://dream.microcms.io/apis/article/' + relate_article.id"><li>{{relate_article.title}}</li></a> -->
              <router-link :to="{name:'article', params:{ id: relate_article.title}}"><li>{{relate_article.title}}</li></router-link>
              <hr class="relate_list_border"/>
            </div>
            <div v-if="relate_articles.length > 0" class="article_ad_bottom">
              <Adsense
                data-ad-client="ca-pub-8143206471999291"
                data-ad-slot="8208446019">
              </Adsense>
            </div>
            <div v-if="this.article" class="article_relation">
              <Adsense
                data-ad-client="ca-pub-8143206471999291"
                data-ad-slot="8162185265">
              </Adsense>
            </div>
          </div>
          <div v-if="this.article" class="column side_bar">
            <p>キーワード検索</p>
            <SearchComponent/>
            <h2>よく見る夢</h2>
              <ThemesComponent/>
            <h2>50音順</h2>
              <InitialComponent />
            <h2>カテゴリー</h2>
              <CategoryComponentCategory/>
            <h2>アプリ</h2>
            <p>夢占い辞典ゆめみんのアプリが登場しました！アプリなので、いつでも素早く簡単に夢の意味を調べられます。ぜひご利用ください。</p>
            <!-- <div class="card app_card"> -->
            <!-- <div style="margin:24px;"> -->
            <div class="appreach">
              <img src="https://play-lh.googleusercontent.com/HLfCp6M7AhYpcmEsa4gOXxIzHYazYbq6F3gEpO481GcM-h5LPXH6Q2DJvrS5UsNAvX-M=s128" alt="夢占い辞典ゆめみん" class="appreach__icon">
              <div class="appreach__detail">
                <p class="appreach__name">夢占い辞典ゆめみん</p>
                <p class="appreach__info">
                <span class="appreach__price">無料</span>
                <span class="appreach__posted">posted with
                  <a href="https://mama-hack.com/app-reach/" title="アプリーチ" target="_blank" rel="nofollow">アプリーチ</a>
                </span>
                </p>
              </div>
              <div class="appreach__links">
                <a href="https://play.google.com/store/apps/details?id=com.ameneko.dream" rel="nofollow" class="appreach__gplink" target="_blank">
                  <img src="https://nabettu.github.io/appreach/img/gplay_ja.png">
                </a>
              </div>
            </div>
            <!-- </div> -->
            <!-- </div> -->
            <div v-if="this.article" class="side_ad">
              <Adsense
                data-ad-client="ca-pub-8143206471999291"
                data-ad-slot="3701076989">
              </Adsense>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import axios from "axios"
import store from '@/store'
import ShareComponentArticle from '@/components/ShareComponentArticle'
import SearchComponent from '@/components/SearchComponent'
import InitialComponent from '@/components/InitialComponent.vue'
import CategoryComponentCategory from '@/components/CategoryComponentCategory'
import ThemesComponent from '@/components/ThemesComponent.vue'
export default {
  components:{
    ShareComponentArticle,
    SearchComponent,
    InitialComponent,
    CategoryComponentCategory,
    ThemesComponent
  },
  data() {
    return {
      article: null,
      relate_articles:  [],
      no_article_message: '',
    };
  },
  created() {
      store.commit('start')
      let url = "https://dream.microcms.io/api/v1/article?filters=title[equals]" + this.$route.params.id
        axios
            .get(url, {
            headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
            })
            .then(res => {
              if(res.data.totalCount != 0){
                this.article = res.data.contents[0]
                this.isSetMeta()
              }else{
                this.isNotSetMeta()
                this.no_article_message ="該当するキーワードがありません"
              }
            })
            .catch(err => {
            console.log(err);
        });
        let relate_url = "https://dream.microcms.io/api/v1/article?filters=title[contains]" + this.$route.params.id + "&limit=100"
        axios
            .get(relate_url, {
            headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
            })
            .then(res => {
              // MicroCMSで、イコール検索とかぶっているワードを取り除く処理
              for (var i = 0; i < res.data.totalCount; i++) {
                if(this.$route.params.id != res.data.contents[i].title){
                  this.relate_articles.push(res.data.contents[i])
                }
              }
            store.commit('end');
            })
            .catch(err => {
            console.log(err);
            store.commit('end');
        });
  },
  watch: {
    '$route' (to) {
        store.commit('start');
        this.$router.go(to.params.id)
    }
  },
  methods:{
    isSetMeta(){
      const title = "「" + this.article.title.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'') + "」" + "の夢の意味は？【夢占い】｜夢占い辞典ゆめみん"
      //h2タグで分割
      const spilit_description = this.article.content.split(/<[hH][2].*?>/);
      //タグを取り除く
      const remove_tag_description = spilit_description[0].replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
      const description = remove_tag_description.replace(/\s+/g, '')
      const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
      const og_image = 'https://dream.ameneko.com/topImage.jpeg'
      document.title = title
      document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
      document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
      document.querySelector("meta[property='og:title']").setAttribute('content', title)
      document.querySelector("meta[name='description']").setAttribute('content', description)
      document.querySelector("meta[property='og:description']").setAttribute('content', description)
    },
    isNotSetMeta(){
      const title = "「" + this.$route.params.id + "」" + "の夢の意味は？【夢占い】｜夢占い辞典ゆめみん"
      const description = "「" + this.$route.params.id+ "」"  + "の夢の意味は？"
      const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
      const og_image = 'https://dream.ameneko.com/topImage.jpeg'
      document.title = title
      document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
      document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
      document.querySelector("meta[property='og:title']").setAttribute('content', title)
      document.querySelector("meta[name='description']").setAttribute('content', description)
      document.querySelector("meta[property='og:description']").setAttribute('content', description)   
    },
  }
}
</script>

<style scoped>
.article{
  margin-top:20px;
  padding:10px 10px 20px 10px;
}
.article_content{
  padding-top:12px;
}
.card-content{
  padding: 8px;
}
h1{
  border-bottom: solid 2px #27556A;
}
h2{
  margin-top:40px;
  border-bottom: solid 1px #27556A;
}
.share{
  margin:40px 0 20px 0; 
}
.article_result{
  padding-left:10px;
  max-width: 540px;
  font-size: .8em;
  text-decoration: underline;
}
.article_title{
  font-weight: bold;
  font-size: 1.6em;
}
.article_title_sub{
  padding-left:5px;
  font-size: .9em;
}
.article_ad_bottom{
  padding-top: 20px;
}
.article_relation{
  padding-top: 20px;
}
.appreach{
  margin-top:20px;
  padding:10px 10px 10px 10px;
  border-radius:10px;
  border: solid 1px #27556A;
}
.appreach__icon{
  max-width: 150px;
}
.appreach__name{
  font-weight: bold;
  font-size: 1.2em;
}
h2{
  font-weight: bold;
  font-size: 1.2em;
  border-bottom: solid 2px #27556A;
  margin: 20px 0 20px 0;
}
div >>> h2{
  font-weight: bold;
  font-size: 1.2em;
  margin: 16px 0 20px;
  background-color: #eee;
  padding: 16px 8px;
  border-radius: 5px;
}
div >>> p{
  font-size: 18px;
  padding: 8px 8px;
}

.relate_list{
  padding: 5px 0 5px 16px;
}
.relate_list_border{
  margin: 4px 24px 4px 0;
  border:none;
  border-top:dashed 1px #e8e8e8;
  height:1px;
  color:#FFFFFF;
}
li{
  position: relative;
  list-style-type: none;

}
li::after {
  display: block;
  content: '';
  position: absolute;
  top: .5em;
  left: -1em;
  width: 6px;
  height: 6px;
  border-right: 1px solid #666;
  border-bottom: 1px solid #666;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.main_bar{
  margin: 0 5px 0 5px;
}
.side_bar{
  margin: 0 5px 0 5px;
}
.side_ad{
  margin: 20px 0 0 0;
}
.app_card{
  border-radius:10px;
  text-align:center;
}
</style>